export function toRoundedPercentage(value: number, total: number): number {
  return total <= 0 ? 0 : Math.round((value / total) * 100);
}

export function isBelowOnePercent(value: number, total: number): boolean {
  return value > 0 && value * 100 < total;
}

export function formatPercentageLabel(value: number, total: number): string {
  return isBelowOnePercent(value, total) ? '<1' : `${toRoundedPercentage(value, total)}`;
}
